// 西暦の日付文字列（YYYY-MM-DD）を和暦表記（例: 平成2年1月1日）に変換する
export function toWareki(dateStr) {
  if (!dateStr) return '';
  // タイムゾーンずれ防止のためローカル時刻の0時として解釈する
  const d = /^\d{4}-\d{2}-\d{2}$/.test(dateStr) ? new Date(`${dateStr}T00:00:00`) : new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '';
  try {
    // 実行環境によりフォーマット文字列が異なるため、パーツから組み立てる
    const parts = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
      era: 'long',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(d);
    const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
    const era = get('era');
    const year = get('year');
    const month = get('month');
    const day = get('day');
    if (!era || !year) return '';
    const yearLabel = year === '1' ? '元' : year;
    return `${era}${yearLabel}年${month}月${day}日`;
  } catch {
    return '';
  }
}
